import React, {
    useMemo,
    useState,
    useEffect,
    useCallback,
    useRef,
} from "react";
import {
    Row,
    Col,
    Button,
    Modal,
    Form,
    Image
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { logout } from "../../utils";
import { toast } from "react-toastify";
import { getFromLS } from "../../utils/storage";
import { FormContext } from "../../reusable-components/InputFields/FormContext";
import Element from '../../reusable-components/InputFields/input';
import * as Icon from "react-bootstrap-icons";
import { AgGridReact } from "ag-grid-react";
import { themeQuartzDark } from 'ag-grid-community';

 
import { Bars } from "react-loader-spinner";
import { PreviewFullWindowModal } from "../../pages/DynamicForm/myforms/PreviewFullWindowModal";
import { json } from "react-router-dom";
import Select, { components, StylesConfig } from "react-select";
import "./clientonboarding.css";

const ClientOnboardingConfigFlow = (props) => {
    const [sourceOptions, setSourceOptions] = useState([
        { value: 'HBSPT', label: 'HubSpot', logo: require("../../pages/vendorimages/HBSPT.png") },
    ])
    const [formOptions, setFormOptions] = useState([
        { value: 'Form 1', label: 'Form 1' }, { value: 'Form 2', label: 'Form 2' }
    ])
    const [selectedSource, setSelectedSource] = useState(
        { value: 'HBSPT', label: 'HubSpot', logo: require("../../pages/vendorimages/HBSPT.png") },
    )
    const [selectedForm, setSelectedForm] = useState(
        { value: 'Form 1', label: 'Form 1' },
    )
    
    const navigate = useNavigate()
    const { Option, Control } = components;
    const IconOption = props => {
        // console.log("ICON OPTION PROPS: ", props)
        return (
            <Option {...props}>
                <img
                    src={props.data.logo}
                    style={{ width: 20, borderRadius: 5, marginRight: 10 }}
                    alt={props.label}
                />
                {props.data.label}
            </Option>
        )
    };
    const IconControl = ({ children, ...props }) => {
        console.log("ICON CONTROL PROPS: ", children)
        return (
            <Control {...props}>
                <img
                    src={props.selectProps.value.logo}
                    style={{ width: 20, borderRadius: 5, marginLeft: 5, marginRight: -1 }}
                    alt={props.label}
                />
                {children}
            </Control>
        );
    };


    return (
        <Row>
            <Row className='no-gutter flex-row-space-center' style={{ marginBottom: 20 }}>
                <p className="display-6" style={{ height: "fit-content", margin: 15, width: "fit-content" }}>Configure client onboarding</p>
                <div className="navigator" style={{ marginBottom: "0rem", width: "fit-content" }}>
                    <Button className="nav-direction" onClick={() => navigate("/clients")}>Clients <Icon.CaretRightFill /></Button>
                </div>
            </Row>
            <Row style={{ padding: "0px 0px" }}>
                <Row className="flex-row-center-center" style={{ marginBottom: 50 }}>
                    <Col md={4} className="flex-row-center-center">
                        <div className="flex-column-center-center config-flow-node">
                            <h6 style={{ marginBottom: "0.75rem" }}>What is the source of truth for clients?</h6>
                            <Select
                                value={selectedSource}
                                onChange={(e) => setSelectedSource(e)}
                                options={sourceOptions}
                                components={{ Control: IconControl, Option: IconOption }}
                                className="form-select custom-select"
                                aria-label="Default"
                                closeMenuOnSelect={true}
                                autosize={true}
                                placeholder="Select the source"
                                menuPosition="fixed"
                                classNamePrefix="react-select"
                            />
                        </div>
                    </Col>
                    <Col md={4}>
                        <Row className="config-flow-connector-container">
                            <Row className="config-flow-connector-wrapper">
                                <Col md={4} className="right-bottom-connector rainbow"></Col>
                            </Row>
                        </Row>
                    </Col>
                    <Col md={4} className="flex-row-center-center">
                    </Col>
                </Row>
                <Row className="flex-row-center-center" style={{ marginBottom: 50 }}>
                    <Col md={4}></Col>
                    <Col md={4} className="flex-row-center-center">
                        <div className="configure-logo-wrapper">
                            <Image src={require("../../pages/vendorimages/undefined.png")} className="configure-logo" rounded />
                            <div className="configure-logo-name">
                                <h6>Cygnus Client <br></br> Master Data</h6>
                            </div>
                        </div>
                    </Col>
                    <Col md={4}></Col>
                </Row>
                <Row className="flex-row-center-center">
                    <Col md={4}></Col>
                    <Col md={4} className="flex-row-center-center">
                        <div className="flex-column-center-center config-flow-node">
                            <h6 style={{ marginBottom: "0.75rem" }}>Which form do you want to use?</h6>
                            <Select
                                value={selectedForm}
                                onChange={(e) => setSelectedForm(e)}
                                options={formOptions}
                                className="form-select custom-select"
                                aria-label="Default"
                                closeMenuOnSelect={true}
                                autosize={true}
                                placeholder="Select the form"
                                menuPosition="fixed"
                                classNamePrefix="react-select"
                            />
                        </div>
                    </Col>
                    <Col md={4} className="flex-row-center-center">
                        <div className="configure-logo-wrapper">
                            {/* <Image src={require("../../pages/vendorimages/undefined.png")} className="configure-logo" rounded /> */}
                            <div className="configure-logo-name">
                                <h6>Clients data</h6>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Row>
        </Row>
    )
}

export default ClientOnboardingConfigFlow;